var bodyEl = jQuery('body');
var didYouMeanEmail = '';
var keepWrittenEmail = false;
var errors_found = [];
var email_flag = false;

$("document").ready(function(){

	const topBar = document.getElementsByClassName('wodu-top-bar');
	const hasClosedTopBar = sessionStorage.getItem('closedTopBar');

	if (topBar.length > 0 && !hasClosedTopBar) {
		const bodyElement = document.body;
	  const closeButton = document.getElementById('wodu-popup-close');
	  bodyElement.classList.add("top-bar-shown");
		check_wodu_top_bar_height();
	  closeButton.addEventListener('click', () => {
	    sessionStorage.setItem('closedTopBar', 'true');
	  });
	}
	// Touch Device Detection
	var isTouchDevice = 'ontouchstart' in document.documentElement;
	if( isTouchDevice ) {
		$('body').removeClass('no-touch');
	}


	function is_touch_enabled() {
		return ( 'ontouchstart' in window ) ||
			   ( navigator.maxTouchPoints > 0 ) ||
			   ( navigator.msMaxTouchPoints > 0 );
	}

	$(document).on('click', '.hidden-content-btn', function (e){
		//jQuery(this).siblings('.accordion:not(.always-opened)').not(jQuery(this)).removeClass("open").addClass("close");
		//jQuery(this).siblings('.accordion:not(.always-opened)').not(jQuery(this)).next().hide();
		const dId = jQuery(this).data("id");
		console.log(dId);
		jQuery("#" + dId).slideToggle(400, function(){
			jQuery('body').trigger('zendeskAppUpdateFrameHeight');
		});
		jQuery(this).toggleClass("close open");
	})

	$(".checkbox input[type=checkbox]").change(function(){
		if ( $(this).is(":checked") ){
			$(this).parent('.checkbox').next('.checkbox-hidden-item').removeClass("hidden");
		}
		else{
			$(this).parent('.checkbox').next('.checkbox-hidden-item').addClass("hidden");
		}
	})

	$(document).on('click', '.tabs a', function (e){
		e.preventDefault();
		currentTab = $(this).parents(".tabs").find(".active").attr("href");
		newTab = $(this).attr("href");
		$(this).parents(".tabs").find("a.active").removeClass("active");
		$(this).addClass("active");
		$(currentTab).hide();
		$(".tab-section").filter( newTab ).show();
		jQuery('body').trigger('zendeskAppUpdateFrameHeight');
	})

	$(".order-entry").on("click", function(e){
		$("#main-screen").toggleClass("d-none d-block");
		$("#booking-details-screen").toggleClass("d-none d-block");
		e.preventDefault();
		jQuery('body').trigger('zendeskAppUpdateFrameHeight');
	})

	$(document).on("click", ".custom-input", function(e){
	    e.stopPropagation();
	    $(".custom-input").removeClass("active");
	    $(this).addClass("active");
	});

	$(document).on("click", '.back-btn', function(e) {
		previousScreen = $(this).data("prev-screen");
		$(this).parents(".page-screen").toggleClass("d-none d-block")
		$("#" + previousScreen).toggleClass("d-none d-block");
		jQuery('body').trigger('zendeskAppUpdateFrameHeight');
	})

	jQuery(".app-html .accordion:not(.always-opened)").on("click", function(){
		jQuery(this).siblings('.accordion:not(.always-opened)').not(jQuery(this)).removeClass("open").addClass("close");
		jQuery(this).siblings('.accordion:not(.always-opened)').not(jQuery(this)).next().hide();
		dId = jQuery(this).data("id");
		jQuery("#" + dId).slideToggle(400, function(){
			jQuery('body').trigger('zendeskAppUpdateFrameHeight');
		});
		jQuery(this).toggleClass("close open");
	})

    pageLoad();

    jQuery('.form-input-field').on('input', function () {
        jQuery(this).removeClass('danger non-verified');
    });

    $(".wodu-popup-close").on("click", function(){
    	$(this).parent().remove();
			$("body").removeClass("top-bar-shown");
    	$("body").css("padding-top",0);
    });

})

function pageLoad(){

	var inputs = document.querySelectorAll('input:not(#phone), textarea');
	  Array.prototype.forEach.call(inputs, function(input) {
	    $(input).on('focus', function() {
	      input.classList.add('focused');
	    });
	    $(input).on('blur', function() {
	      input.classList.remove('focused');
	    });
		$(input).on('keyup change', function() {
	      if (input.value.length === 0) {
	        input.classList.add('empty');
	      } else {
	        input.classList.remove('empty');
	      }
	    });
	  });

	try{ // Select2 Try
		jQuery('select.custom-select2-init-default').select2();
	}catch( e ){
		errors_found.push( e.message );
	}

    jQuery('#email_address').trigger('input');
    jQuery('.customer-field-value-changed').trigger('change');
}

function fixShortCode( txtBody ){
	if ( brandName !== 'undefined' ){
		txtBody = txtBody.replace("[BRAND]", brandName );
	}

	if ( pageTitle !== 'undefined' ){
		txtBody = txtBody.replace("[PRODUCT/PAGE]", pageTitle);
	}

	if ( $("#_elev_io #form-first-name").length > 0 ){
		var name = $("#_elev_io #form-first-name").val();

    if ( name.length > 3 ){
        name = "- " + name;
    }
		txtBody = txtBody.replace("[NAME]", name );
	}

	return txtBody;
}

function initDrillDownMenu( isZDApp = false ){
	// Loop through each dropdown parent
	$('.drilldown-menu .has-dropdown-folder').each(function() {

		// Get first a tag inside dropdown and get attributes
		let parentLink = $(this).children().first('a');
		let aText = parentLink.text();
		let aHref = parentLink.attr('href');
		let aClass = parentLink.attr('class');

		// Check if parentLink has a href attribute that isn't empty or '#'
		if(aHref !== '' && aHref !== '#') {

			// Select direct sibling that has class 'navbar-dropdown' and add a link to it
			//parentLink.next('.is-dropdown').prepend('<a href="' + aHref + '" class="' + aClass + '">' + aText + '</a>');
		}

		parentLink.next('.is-dropdown').append('<div class="navbar-dropdown-back navbar-dropdown-up-one-level">Up One Level</div> | <div class="navbar-dropdown-back navbar-dropdown-top-level">Top Level</div>');
	});

	/*
	** Active drilldown level
	*/
	$('.drilldown-menu .has-dropdown-folder > div').on('click', function(event) {
		event.preventDefault();
		$(this).next('.is-dropdown').addClass('is-active');
		if ( isZDApp ){
    	jQuery('body').trigger('zendeskAppUpdateFrameHeight');
		}
	});

	/*
	** Deactivate drilldown level
	*/
	$('.drilldown-menu .navbar-dropdown-up-one-level').on('click', function(event) {
		event.preventDefault();
		$(this).parent('.is-dropdown').removeClass('is-active');
		if ( isZDApp ){
    	jQuery('body').trigger('zendeskAppUpdateFrameHeight');
		}
	});

	$('.drilldown-menu .navbar-dropdown-top-level').on('click', function(event) {
		event.preventDefault();
		$(this).parents('.is-dropdown').removeClass('is-active');
		if ( isZDApp ){
    	jQuery('body').trigger('zendeskAppUpdateFrameHeight');
		}
	});
}
